
import { computed, defineComponent, onMounted, onUnmounted, Ref, ref, WritableComputedRef } from "vue";

import { AppHelpers } from "@/core/modules/helpers/AppHelpers";
import { eventBus } from "@/core/modules/eventBus/EventBus";
import { storeTypes } from "@/core/modules/store/types";
import { useLocale } from "@/core/modules/locale/module";
import { useStore } from "@/core/modules/store/module";
import { zebraPrintModel } from "../models/ZebraPrintModel";

export default defineComponent({
  name: "ZebraPrintView",
  props: {
    show: { type: Boolean, default: false },
  },
  emits: ["update:show"],
  setup(props, { emit }) {
    const { t } = useLocale();
    const store = useStore();
    let eventBusId: string | undefined = undefined;

    const isVisible: WritableComputedRef<boolean> = computed({
      get: () => props.show,
      set: (val) => emit("update:show", val),
    });

    const zebraPrintState: Ref<"connected" | "disconnected"> = ref("disconnected");

    const connect = async (): Promise<void> => {
      await AppHelpers.tryOrToast(
        async () => {
          store.commit(storeTypes.mutations.loadingStart);

          isVisible.value = false;

          await zebraPrintModel.connect();
        },
        "zebraPrintConnection",
        t,
        () => store.commit(storeTypes.mutations.loadingStop),
        false
      );
    };

    const disconnect = async (): Promise<void> => {
      await AppHelpers.tryOrToast(
        async () => {
          store.commit(storeTypes.mutations.loadingStart);

          isVisible.value = false;

          zebraPrintModel.setState("disconnected");
        },
        "zebraPrintConnection",
        t,
        () => store.commit(storeTypes.mutations.loadingStop),
        false
      );
    };

    onMounted(() => {
      eventBusId = eventBus.on("zebraPrintToggleStateView", async (state: "connected" | "disconnected" | undefined) => {
        if (state === undefined) return;
        zebraPrintState.value = state;
      });

      zebraPrintState.value = zebraPrintModel.getState();
    });

    onUnmounted(() => {
      if (eventBusId !== undefined) eventBus.off(eventBusId);
    });

    return {
      connect,
      disconnect,
      isVisible,
      t,
      zebraPrintState,
    };
  },
});
